import { Container, Row, Col, Button, Form } from 'react-bootstrap';
import '../../App.css';
import '../../css/bootstrap.scss';
import signup_banner from "../../images/fx-rates.png";
import Header from '../Includes/Header';
import Footer from '../Includes/Footer';
import arrow_left from "../../images/arrow-left.png";
import { useNavigate } from 'react-router-dom';
import { useState, useRef } from 'react';
import config from '../../config';
import axios from 'axios';
import { Field, reduxForm, InjectedFormProps } from 'redux-form';
import renderField from '../renderField';
import { connect } from 'react-redux';
import { setEmail, setdriverLicenseFrontendPic, setdriverLicenseBackendPic, setwizardPageNumber } from '../authslice';
import { RootState } from '../store'; // Import the RootState type
import { useDispatch, useSelector } from 'react-redux';
import { ToastBox, notifyError, notifySuccess } from 'MyComponents/Toaster';
import { AxiosError } from 'axios';
import SendOTPModal from '../Camera/SendOTPModal';
import BackButton from '../Includes/BackButtonResetPassword';
import Spinner from 'react-bootstrap/Spinner';
import { isEmailExist, validateEmail } from '../../Utils/user';
import { useTranslation } from 'react-i18next';


interface FormData {
    email: string;
}

interface Props { };

const ResetPassword: React.FC<Props & InjectedFormProps<{}, Props, FormData>> = (props: any) => {
    const { t } = useTranslation();

    const { handleSubmit } = props; // Destructure change and changeStep from props
    // Inside your component function
    const dispatch = useDispatch();
    const [validated, setValidated] = useState(false);

    const [showModal1, setShowModal1] = useState(false);
    const modalRef1 = useRef<string | null>(null);

    const [isSubmitted, setIsSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);
    const [emailSent, setEmailSent] = useState(false);
    const startLoading = () => {
        setLoading(true);
        // Additional actions when loading starts
    };


    const handleShowModal1 = () => {
        setShowModal1(true);
    };
    const handleCloseModal1 = async () => {
        setShowModal1(false);
        // const LoginStatus = await verifyFace(email,faceID);

        // if(LoginStatus === true){
        //     notifySuccess("User Login Successfully");
        // }
        // console.log(LoginStatus);

    };
    const updateSrcModal1 = (newState: any) => {

    };

    const handleChange = (e: any) => {
        setValidated(false);
        setEmailSent(false);
    };

    const initiatePasswordRecovery = (email: string) => {
        return axios.post(`${config.NODE_API_BASE_URL_V2}/wso2/initiatePasswordRecovery`, {
            email,
        });
    };

    const submitForm = async (formValues: FormData) => {
        setValidated(false);
        setIsSubmitted(true);
        setLoading(true);

        try {
            const emailExists = await isEmailExist(formValues.email);
            if (!emailExists) {
                setValidated(true);
                setLoading(false);
                setIsSubmitted(false);
                return;
            }

            await initiatePasswordRecovery(formValues.email);
            setEmailSent(true);
        } catch (error: any) {
            if (error.response?.status === 404) {
                setValidated(true);
            } else {
                notifyError("Something went wrong. Please try again.");
            }
        } finally {
            setLoading(false);
            setIsSubmitted(false);
        }
    };



    return (
        <>
            <Header />
            <SendOTPModal
                show={showModal1}
                handleClose={handleCloseModal1}
                title="Take a selfie"
                ref={modalRef1}
                side=""
                updateSrc={updateSrcModal1}

            // modalState={frontsideImage}
            />
            <ToastBox />
            <div className='container-fluid'>
                <div className='row'>

                    <div className='col-md-1'>

                    </div>

                    <div className='col-md-5'>
                        <div className='mt-5 px-4 '>
                            <br />

                            <BackButton />

                            <br />
                            <br />

                            <p className='text-primary fw-medium fs-5 py-4 '>{t('login.reset_title')}</p>
                            <Form noValidate={true} onSubmit={handleSubmit(submitForm)}>

                                <label htmlFor="password" className="form-label">{t('login.enter_email')}</label>
                                <Field
                                    name="email"
                                    type="email"
                                    component={renderField}
                                    className="form-control rounded-5 py-2"
                                    placeholder={t('login.enter_email')}
                                    id="email"
                                    validate={validateEmail} // Apply validation function
                                    onChange={handleChange}
                                />
                                {validated &&
                                    <p className='text-danger mb-0  mt-2 fw-bold'>{t('login.no_account_email')}</p>
                                }
                                {emailSent &&
                                    <p className='text-success mb-0 mt-2 fw-bold'>{t('login.email_sent')}</p>
                                }

                                <div className='col-md-5 mt-3'>

                                    <Button variant="primary" type="submit" className="btn btn-primary rounded-5 mt-3" disabled={(loading && isSubmitted)}>
                                        {loading && isSubmitted && (
                                            <Spinner
                                                as="span"
                                                animation="border"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                                className='mx-2'
                                            />
                                        )}
                                        <span>{t('common.continue')}</span>
                                    </Button>{' '}
                                </div>
                            </Form>

                        </div>
                    </div>
                    <div className='col-md-6 text-center' style={{ background: "#EDF7F3" }}>
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                        <img src={signup_banner} className="img-fluid" style={{ maxWidth: 500, width: "100%" }} alt="banner" />
                        <br />
                        <br />
                        <br />
                        <h2>{t('common.all_in_one')}</h2>
                        <p className='text-secondary'>{t('common.all_in_one_desc')}</p>
                    </div>
                </div>
            </div>
            <Footer full={false} />
        </>
    );
}


const mapStateToProps = (state: RootState) => ({
    initialValues: {
        email: '', // Provide an empty string as the initial value


    },
});

const form = reduxForm<{}, Props, FormData>({
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    form: 'wizard',
    enableReinitialize: true,

})(ResetPassword);

export default connect(mapStateToProps)(form);